import fetchAPI from '../utils/service';

function uploadFileRequest(payload) {
  return {
    type: 'UPLOAD_FILE_REQUEST',
    payload,
  };
}
function uploadFileSuccess(payload) {
  return {
    type: 'UPLOAD_FILE_SUCCESS',
    payload,
  };
}
function uploadFileFailure(payload) {
  return {
    type: 'UPLOAD_FILE_FAILURE',
    payload,
  };
}

function uploadFile(payload, callback) {
  return async (dispatch) => {
    dispatch(uploadFileRequest(payload));
    try {
      const data = new FormData();
      data.append('file', payload.file);
      const res = await fetchAPI({
        endpoints: '/upload',
        method: 'POST',
        data,
        headers: {
          'content-type': 'multipart/form-data',
        },
      });
      if (res.status === 201) {
        dispatch(uploadFileSuccess(res.data));
        callback({ [payload.type]: { value: res.data.location } });
      } else {
        dispatch(uploadFileFailure({ message: 'Upload failed' }));
      }
    } catch (error) {
      dispatch(uploadFileFailure(error));
    }
  };
}

function logoutUpload() {
  return {
    type: 'LOGOUT',
  };
}

export {
  uploadFile,
  logoutUpload,
};



// WEBPACK FOOTER //
// ./src/actions/upload.js